import { GET_PROFILE_DATA, SOCIAL_CALLBACK } from 'constants/api'
import Button from 'components/button'
import ButtonCloseMenu from 'components/button-close'
import { useContext, useEffect, useState } from 'react'
import useRouter from 'hooks/use-router'
import ProfilePhoneUpdate from 'views/profile-phone-update'
import { useSession } from 'contexts/session-context'
import axios, { AxiosError } from 'axios'
import { LoaderContext } from 'contexts/loader-context'
import ErrorView from 'components/error-view'

const AccountLinking = ({ setPopUpFalse }: any) => {
  const [otp, setOtp] = useState(false)
  const [linkAccount, setLinkAccount] = useState(false)
  const { push } = useRouter()
  const [{ user, data: session }, { setUser }] = useSession()
  const { setLoad } = useContext(LoaderContext)
  const [error, setError] = useState(null)

  const toggleOtp = () => {
    setOtp(!otp)
  }

  const rankingRedirect = () => {
    push('/ranking')
  }

  useEffect(() => {
    if (user?.profileLinkings?.some((profile) => profile.provider === "SumaSix")) {
      push('/ranking')
    }
  }, [])

  const alreadyPhone = async () => {
    setLoad(true)
    try {
      const response = await axios.put(`${SOCIAL_CALLBACK}sumasix/link?code=${user?.phoneNumber}`, {},
        { headers: { Authorization: `Bearer ${((session as any)?._tokenResponse as any)?.idToken}`, 'Ph-Api-Id': PH_API_ID ?? 1 } }
      )

      if (response.status === 200) {
        const responseProfile = await axios.get(`${GET_PROFILE_DATA}`,
          { headers: { Authorization: `Bearer ${((session as any)?._tokenResponse as any)?.idToken}`, 'Ph-Api-Id': PH_API_ID ?? 1 } }
        )

        setUser(responseProfile.data)
        setLinkAccount(true)
      }

    } catch (err) {
      const typedError = err as AxiosError
      const { code } = typedError.response?.data || {}
      setError(code)
    } finally {
      setLoad(false)
    }
  }

  const handleMenu = () => {
    push('/home')
  }

  const handleButton = () => {
    setError(null)
  }

  useEffect(() => {
    if (otp && !linkAccount && user.phoneNumber) {
      const verifyPhone = async () => {
        await alreadyPhone()
      }

      verifyPhone()
    }
  }, [otp])

  if (error) {
    return <ErrorView buttonMenu={handleMenu} code={error} onRetry={handleButton} />
  }

  if (linkAccount) {
    return (
      <div className="w-full overflow-auto relative flex-1 bg-white justify-center">
        <ButtonCloseMenu paramFn={setPopUpFalse} />

        <div className='sumasix-connection-popup mx-auto'>
          <span className='invislbe'></span>

          <div className='space-y-4'>
            <h2 className='title'>
              VINCULASTE TU CUENTA CON ÉXITO
            </h2>

            <p className='sumasix-connection-text'>
              Compra latas de  Sol Clamato en tiendas Six usando tu cuenta de SumaSix, el que quede en 1er lugar en el ranking al finalizar la dinámica ganará, ¡suerte!
            </p>
          </div>

          <Button onClick={rankingRedirect}>
            VER MI POSICIÓN EN EL RANKING
          </Button>
        </div>
      </div>
    )
  }

  if (otp) {
    return (
      <div className="w-full overflow-auto relative flex-1 bg-white">
        <ButtonCloseMenu paramFn={setPopUpFalse} />

        <div className='h-full mt-6'>
          <ProfilePhoneUpdate sumasix={true} toggleOtpSS={setPopUpFalse} linkAccountSS={setLinkAccount} />
        </div>
      </div>
    )
  }

  return (
    <div className="w-full overflow-auto relative flex-1 bg-white justify-center">
      <ButtonCloseMenu paramFn={setPopUpFalse} />

      <div className='sumasix-connection-popup mx-auto'>
        <h2 className='title'>
          VINCULA TU CUENTA SUMASIX Y PARTICIPA POR UN AUTO
        </h2>

        <img src={`${AZURE_BASE_URL}/pop-up-vincula_tu_cuenta.webp`} alt="Suma Six - Auto" />

        <Button onClick={toggleOtp}>
          EMPEZAR
        </Button>
      </div>
    </div>
  )
}

export default AccountLinking
